module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTAzIiB2aWV3Qm94PSIwIDAgMTcgMTAzIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPg0KPHBhdGggZD0iTTcuOTk5OTggMTYuOTk5OUw3Ljk5OTk5IDEwM0g4Ljk5OTk5TDguOTk5OTcgMTYuOTk5OUM4Ljk5OTk3IDEyLjM3OTMgMTAuMjA4NyAxMS44MzM5IDE2Ljk5OTkgMTEuNTYxMkwxNi45OTk3IDBIMEwwLjAwMDIyODg4MiAxMS42MDY3QzYuMjE1NCAxMS44Nzk0IDcuOTk5OTggMTIuMzc5MyA3Ljk5OTk4IDE2Ljk5OTlaIiBmaWxsPSIjRURFREVEIi8+DQo8L3N2Zz4NCg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/weiter.svg
// module id = Lod0
// module chunks = 0